/**
 * The record's ref to the first run's canvas. Its own module, with no
 * imports, so the public index can export it without reaching the first
 * run's payload.
 */
export const CANVAS_REF = "first_run:canvas";
